import { render, staticRenderFns } from "./info.vue?vue&type=template&id=518505de"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=518505de&lang=scss"
import style1 from "./info.vue?vue&type=style&index=1&id=518505de&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518505de')) {
      api.createRecord('518505de', component.options)
    } else {
      api.reload('518505de', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=518505de", function () {
      api.rerender('518505de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/tabs/info.vue"
export default component.exports